<div class="container mt-4">

    <!-- Contenido -->
    <div class="row justify-content-center">
        <div class="col-md-7 col-xl-5">

            <div class="mcard">
                <h3 *ngIf="!isEditMode">Crea tu minibio</h3>
                <h3 *ngIf="isEditMode">Edita tu minibio</h3>




                <form [formGroup]="bioForm" class="form-floating mt-4">
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="title">
                        <label for="floatingInput">Nombre de la bio</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="description">
                        <label for="floatingInput">Descripción</label>
                    </div>

                    <div class="mb-3">
                        <label for="formFile" class="form-label">Imagen de perfil</label>
                        <input class="form-control" (change)="uploadFile($event)" type="file" id="formFile">
                    </div>

                    <img *ngIf="downloadURL || mainImage" [src]="(downloadURL | async) || mainImage" class="img-thumbnail" alt="...">

                    <div class="progress mt-1 mb-3">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{'width': percent + '%' }" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>

                    <div class="form-floating mb-3 d-none">
                        <input type="text" class="form-control" id="floatingInput" formControlName="image">
                        <label for="floatingInput">Url imagen</label>
                    </div>

                    <h5>Enlace 1</h5>
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="linkTitle1">
                        <label for="floatingInput">Titulo enlace</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="linkUrl1">
                        <label for="floatingInput">Url enlace</label>
                    </div>

                    <h5>Enlace 2</h5>
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="linkTitle2">
                        <label for="floatingInput">Titulo enlace</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="linkUrl2">
                        <label for="floatingInput">Url enlace</label>
                    </div>


                    <h5>Enlace 3</h5>
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="linkTitle3">
                        <label for="floatingInput">Titulo enlace</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" formControlName="linkUrl3">
                        <label for="floatingInput">Url enlace</label>
                    </div>

                    <button *ngIf="!isEditMode" type="button" (click)="saveMinibio()" class="btn btn-save">Guardar</button>
                    <button *ngIf="isEditMode" type="button" (click)="updateMinibio()" class="btn btn-save">Actualizar</button>
                </form>

            </div>

        </div>
    </div>


</div>